import { device } from 'components/styles/MediaQuery';
import styled from 'styled-components';

export const ScAuroraPanel = styled.div`
  position: relative;
  display: flex;
  height: 80px;
  border-radius: 8px;
  background: ${({ theme }) => theme.grayColor6};
  overflow: hidden;
  cursor: pointer;

  & .desktop {
    @media (${device.mobile}) {
      display: none;
    }
  }

  & .mobile {
    display: none;

    @media (${device.mobile}) {
      display: block;
    }
  }

  & .bg {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    scale: 1;
  }

  & .inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0 12px;
    z-index: 2;
  }

  & .content {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  & .content-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;

    @media (${device.mobile}) {
      align-items: flex-start;
      gap: 4px;
    }
  }

  & .title {
    display: flex;
    gap: 4px;
    color: ${({ theme }) => theme.whiteColor};
    font-size: 12px;
    font-weight: 700;
    line-height: 110%;

    @media (${device.mobile}) {
      font-size: 16px;
    }
  }

  & .crystal {
    width: 22px;
    height: 100%;

    @media (${device.mobile}) {
      width: 38px;
    }
  }

  & .spins-left {
    padding: 4px 8px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.2);
    color: ${({ theme }) => theme.whiteColor};
    font-size: 10px;
    font-weight: 700;
    line-height: 110%;
    letter-spacing: 0;
  }
`;
